module.exports = __webpack_public_path__ + "static/media/Graphik-Medium.871d0706.woff2";